module.exports = __webpack_public_path__ + "img/8.afe35392.png";